import { toServerFormat } from 'core-components/helpers/date'
import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'
import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'

import { getAllWrappersInPage } from './getAllWrappersInPage'

export const getVersion = (sitePage: ISitePage, flexSettings: IFlexLayout) => {
  if (!sitePage.defaultSettings.version) {
    return undefined
  }
  const version = sitePage.defaultSettings.version
  let localVersion = ''

  Object.keys(getAllWrappersInPage(sitePage.id, flexSettings)).forEach((el: any) => {
    if (version) {
      localVersion =
        new Date(flexSettings[el].version) > new Date(version) ? flexSettings[el].version : version
    } else {
      localVersion = flexSettings[el].version
    }
  })
  return new Date(localVersion) < new Date(sitePage.defaultSettings.version)
    ? toServerFormat(new Date(localVersion))
    : undefined
}
